.header {
  background: var(--color-primary);
  border-bottom: 1px solid #bbb;
  margin: 0;
}

.section {
  margin: 0 auto;
}

.content {
  align-items: center;
  display: flex;
  gap: 1rem;
  padding: 0.5rem 0;
}

.brand {
  flex-shrink: 0;
}

.brandHeading {
  height: 50px;
  margin: 0;
  text-align: left;
  width: 140px;
}

.brandHeading > span {
  display: none;
}

.logoLink {
  display: inline-block;
  line-height: 0;
  padding: 0;
}

.navigation {
  align-items: center;
  display: flex;
  flex: 1;
  text-align: center;
}

.actions {
  margin-left: auto;
  text-align: right;
  width: 256px;
}

.navItem {
  color: var(--color-text);
  display: block;
  font-family: var(--font-family-base);
  font-weight: 400;
  text-align: left;
  text-decoration: none;
}

.navItem:hover {
  text-decoration: underline;
}

.navIcon {
  display: inline-flex;
  margin-right: 0.35rem;
  vertical-align: middle;
}

.navHeading {
  color: var(--color-text);
  font-size: var(--font-size-small);
  font-weight: 700;
  line-height: 1.5;
  margin-top: 0.5rem;
  text-transform: uppercase;
}

.navHeading:first-child {
  margin-top: 0;
}

@media (max-width: 767px) {
  .content {
    gap: 0.5rem;
  }

  .navigation {
    display: none;
  }

  .actions {
    min-width: 0;
    width: auto;
  }

  .brand {
    flex-shrink: 1;
    min-width: 96px;
  }

  .brandHeading {
    height: auto;
    width: auto;
  }

  .logoLink svg {
    height: auto;
    max-width: 100%;
  }
}
